import React, { use, useEffect, useState } from 'react'
import { Getdata } from '../helpers/api.service';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

const News = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()

    const fetchData = () => {
        Getdata(process.env.REACT_APP_URL + `/front/news/fetch/${process.env.REACT_APP_SUBDOMAIN}`)
            .then((res) => {
                console.log("News API response:", res);
                if (res?.data) {
                    setNews(res.data); // depends on API response structure
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching news:", err);
                setLoading(false);
            });

    }
    useEffect(() => {
        fetchData();
    }, []);
    return (
        <div className="py-16 bg-white">

            <div>
                <h2 className="text-f100 text-primary_main text-center font-extrabold mb-12">
                    News
                </h2>
            </div>
            <div className='p-6 space-y-6 text-left'>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 max-w-6xl  mx-2 sm:mx-auto'>

                    {news.length > 0 && news.map((item, index) =>
                    (
                        <div className='bg-[#F9F5FF] border-[#EAEAEA] border-2 rounded-lg ' key={index}>
                            <img
                                className='w-full h-[200px] sm:h-[230px] object-cover cursor-pointer'
                                onClick={() => navigate(`/news/${item.title}`)}
                                src={item.image}
                                alt={item.title}
                            />
                            <div className=" relative flex justify-between text-gray-800 px-4  mb-2   mx-auto">
                                <div>
                                    <h3 className="text-sm font-semibold pt-[10px]  ">
                                        {item.title}
                                    </h3>
                                    <h3 className="text-sm text-gray-400 font-normal">
                                        {dayjs(item.createdAt).format("DD MMM YYYY")}
                                    </h3>

                                </div>

                            </div>
                        </div>
                    ))
                    }
                </div>
                {
                    news.length === 0 && <div className="h-[50vh] flex items-center justify-center w-full">
                        <h1 className="text-center text-gray-400">No Data Found</h1>
                    </div>
                }
            </div>

        </div>
    )
}

export default News